module.exports = __webpack_public_path__ + "img/e.45b76511.png";